import { render, staticRenderFns } from "./urgency_list.vue?vue&type=template&id=556151d5&scoped=true&"
import script from "./urgency_list.vue?vue&type=script&lang=js&"
export * from "./urgency_list.vue?vue&type=script&lang=js&"
import style0 from "./urgency_list.vue?vue&type=style&index=0&id=556151d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556151d5",
  null
  
)

export default component.exports